// 全局路由前置拦
const routerBefore = async (to, from, next) => {
  let ua = navigator.userAgent;
  let fullPath=to.fullPath
  if(!(!!ua.match(/AppleWebKit.*Mobile.*/))){
    if(to.name == 'CareerList'){
      location.href = process.env.VUE_APP_MYIHU_API + '/career/list.php';
    }else{
      location.href = process.env.VUE_APP_MYIHU_API + '/career'+ fullPath;
    }
  }else{
    document.title = to.meta.title;
    next();
  }
}
export {
  routerBefore
}
